import { render, staticRenderFns } from "./EvidencijaKretanjaVozila.vue?vue&type=template&id=ac172a82&scoped=true&"
import script from "./EvidencijaKretanjaVozila.vue?vue&type=script&lang=ts&"
export * from "./EvidencijaKretanjaVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac172a82",
  null
  
)

export default component.exports